import {
  IBitCondition,
  IBitConditionExecutor,
  IEntity,
  IStatus
} from "../../types";

// comparators
const greaterThan = (left: number, right: number) => left > right;
const greaterThanOrEqual = (left: number, right: number) => left >= right;
const lessThan = (left: number, right: number) => left < right;
const lessThanOrEqual = (left: number, right: number) => left <= right;

const equal = <T>(left: T, right: T) => left === right;
const notEqual = <T>(left: T, right: T) => left !== right;
const always = <T>(left: T, right: T) => true || left || right;
const never = <T>(left: T, right: T) => false && left && right;

const baseComparators = { equal, notEqual, always, never };
// prettier-ignore
const numericComparators = { greaterThan, greaterThanOrEqual, lessThan, lessThanOrEqual };

export const comparators: IBitConditionExecutor = {
  ...baseComparators,
  ...numericComparators
};

export const check = (
  actors: IEntity[],
  targetIndex: number,
  payload: IBitCondition
) => {
  if (!payload) return false;
  const actor = actors[targetIndex];
  // payload is not spreaded yet to help out the type checker
  // stats checks
  if (payload.left !== "status") {
    const { key, left, right } = payload;
    const { value, max } = actor.stats[left];
    return comparators[key](value / max, right);
  }
  // status checks

  // TODO: revisit this logic if more comparators are added, like 'only'
  // undefined is added to handle empty statuses
  const { key, right } = payload;
  let statuses: (IStatus | undefined)[] = [undefined];
  if (actor.statuses.length !== 0) statuses = actor.statuses;
  const result = statuses.some(status =>
    baseComparators[key](status?.key, right)
  );
  return result;
};
